(function ($) {
  $(document).ready(function () {
    if ($(".quote-slider").length > 0) {
      setTimeout(function () {
        $(".quote-slider .quote-wrap").css({opacity: "1"});
      }, 500);
      if ($(".quote-slider .quote-wrap .quote").length >= 2) {
        $(".quote-slider .quote-wrap").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          infinite: true,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                draggable: true,
                arrows: false,
                dots: true
              },
            },
          ]
        });
      }
    }
  });
})(jQuery);